namespace RioERP.Masters {
    export interface WhatsAppGatewaySettingsRow {
        Id?: number;
        ApiKey?: string;
        ApiUrl?: string;
        Sender?: string;
        IsActive?: number;
    }

    export namespace WhatsAppGatewaySettingsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ApiKey';
        export const localTextPrefix = 'Masters.WhatsAppGatewaySettings';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            ApiKey = "ApiKey",
            ApiUrl = "ApiUrl",
            Sender = "Sender",
            IsActive = "IsActive"
        }
    }
}
